import type { Dict } from "./es";

const en: Dict = {
  "nav.dashboard": "Home",
  "nav.certificates": "My certificates",
  "nav.request": "Request new",
  "nav.documents": "Documents",
  "nav.profile": "My profile",
  "nav.help": "Help",
  "nav.portal": "My PahCertificar",

  "common.loading": "Loading…",
  "common.continue": "Continue",
  "common.back": "Back",
  "common.next": "Next",
  "common.submit": "Submit",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.edit": "Edit",
  "common.download": "Download",
  "common.view": "View",
  "common.close": "Close",
  "common.search": "Search",
  "common.logout": "Sign out",
  "common.required": "Required",
  "common.optional": "Optional",
  "common.today": "Today",
  "common.days": "days",
  "common.yes": "Yes",
  "common.no": "No",

  "status.active": "Active",
  "status.expiring": "Expiring soon",
  "status.expired": "Expired",
  "status.pending": "In progress",
  "status.verified": "Verified",
  "status.rejected": "Rejected",
  "status.revoked": "Revoked",
  "status.issued": "Issued",
  "status.draft": "Draft",
  "status.uploaded": "Uploaded",
  "status.missing": "Missing",

  "dash.greeting_morning": "Good morning",
  "dash.greeting_afternoon": "Good afternoon",
  "dash.greeting_evening": "Good evening",
  "dash.welcome_subtitle": "Here's what's happening with your certificates today.",
  "dash.stat_active": "Active certificates",
  "dash.stat_expiring": "Expiring (90 days)",
  "dash.stat_in_progress": "In progress",
  "dash.stat_documents": "Uploaded documents",
  "dash.your_certs": "Your certificates",
  "dash.view_all": "View all",
  "dash.quick_actions": "Quick actions",
  "dash.qa_new_cert": "Request a certificate",
  "dash.qa_new_cert_desc": "Start a new request in 3 steps",
  "dash.qa_upload": "Upload a document",
  "dash.qa_upload_desc": "Keep your documents ready for future requests",
  "dash.qa_renew": "Renew certificate",
  "dash.qa_renew_desc": "Renew before expiry without starting over",
  "dash.recent_activity": "Recent activity",
  "dash.no_activity": "When something happens to your certificate, it'll show up here.",
  "dash.empty_title": "No certificates yet",
  "dash.empty_body": "Start your first request. We'll guide you step by step.",
  "dash.start_first": "Start my first certificate",
  "dash.expiring_banner": "You have {count} certificate(s) expiring soon",
  "dash.expiring_cta": "Renew now",

  "cert.title": "My certificates",
  "cert.subtitle": "All your issued, pending and expired certificates.",
  "cert.filter_all": "All",
  "cert.filter_active": "Active",
  "cert.filter_pending": "In progress",
  "cert.filter_expired": "Expired",
  "cert.empty_filter": "No certificates in this status.",
  "cert.holder": "Holder",
  "cert.serial": "Serial number",
  "cert.issued_on": "Issued",
  "cert.expires_on": "Expires",
  "cert.issuer": "Issuer",
  "cert.days_remaining": "{days} days remaining",
  "cert.expired_ago": "Expired {days} days ago",
  "cert.download_pfx": "Download PFX",
  "cert.download_cer": "Download .cer",
  "cert.renew": "Renew",
  "cert.revoke": "Revoke",
  "cert.timeline_title": "Timeline",
  "cert.docs_title": "Associated documents",
  "cert.details_title": "Technical details",
  "cert.spec_algo": "Algorithm",
  "cert.spec_key": "Key size",
  "cert.spec_validity": "Validity",
  "cert.spec_format": "Format",
  "cert.back_to_list": "Back to my certificates",
  "cert.requests_title": "Requests",
  "cert.requests_subtitle": "Status for your requests and files published by our team.",
  "cert.no_requests": "No active requests",
  "cert.no_requests_body": "When our team creates or updates a request, it will appear here.",
  "cert.open_request": "View request",
  "cert.request_detail_title": "Request detail",
  "cert.request_not_found": "Request not found",
  "cert.request_status": "Status",
  "cert.request_created_on": "Created",
  "cert.request_updated_on": "Updated",
  "cert.request_artifacts": "Available files",
  "cert.no_public_artifacts": "No files have been published for this request yet.",
  "cert.class": "Class",
  "cert.validity": "Validity",
  "cert.download_artifact": "Download file",
  "artifact.rut": "RUT",
  "artifact.camara_comercio": "Chamber of commerce",
  "artifact.cedula": "ID document",
  "artifact.poder": "Power of attorney",
  "artifact.formulario": "Form",
  "artifact.attachment": "Attachment",
  "artifact.response_document": "Response document",

  "type.factura_electronica": "E-invoicing",
  "type.firma_digital": "Digital signature",
  "type.ssl": "SSL",
  "type.autenticacion": "Authentication",
  "type.firma_natural": "Digital Signature (Individual)",
  "type.firma_natural_desc": "Virtual-token digital signature for an individual.",
  "type.firma_natural_rut": "Digital Signature (Individual with RUT)",
  "type.firma_natural_rut_desc": "Virtual-token digital signature for an individual registered in the RUT.",
  "type.firma_representante": "Digital Signature (Legal Representative)",
  "type.firma_representante_desc": "Virtual-token digital signature tied to the legal-representative role.",
  "type.firma_juridica": "Digital Signature (Company Membership)",
  "type.firma_juridica_desc": "Virtual-token digital signature tied to a company relationship.",
  "type.profesional": "Digital Signature (Licensed Professional)",
  "type.profesional_desc": "Virtual-token digital signature tied to an accredited profession.",
  "type.funcion_publica": "Digital Signature (Public Service)",
  "type.funcion_publica_desc": "Virtual-token digital signature tied to a role in a public entity.",
  "type.funcion_publica_siif": "Digital Signature (SIIF Nación Public Service)",
  "type.funcion_publica_siif_desc": "Virtual-token digital signature for holders who operate with SIIF Nación.",
  "type.comunidad_academica": "Digital Signature (Academic Community)",
  "type.comunidad_academica_desc": "Virtual-token digital signature tied to an academic institution.",
  "type.facturacion": "DIAN e-Invoicing",
  "type.facturacion_desc": "Online request available with a one-year validity period.",

  "req.title": "New request",
  "req.progress": "Step {current} of {total}",
  "req.step1": "Type",
  "req.step2": "Data",
  "req.step3": "Documents",
  "req.step4": "Review",
  "req.step1_title": "What kind of certificate do you need?",
  "req.step1_subtitle": "E-invoicing comes first. You can then choose from eight virtual-token digital signatures, all started through PahCertificar.",
  "req.token_catalog_title": "Next, virtual-token digital signatures",
  "req.token_catalog_subtitle": "Choose the option that matches your identity or role.",
  "req.available_online": "Available online",
  "req.token_available": "Assisted purchase",
  "req.token_note": "Choose the validity period. PahCertificar supports the purchase and follow-up and securely stores the files added to your account. When you continue, you will complete payment and supporting documents in the secure channel presented by the platform.",
  "req.token_cta": "Continue purchase",
  "req.token_footer_hint": "For a virtual-token signature, choose the validity period and use “Continue purchase” in the selected card.",
  "req.step2_title": "Tell us about you",
  "req.step2_subtitle": "Just the essentials. Your data stays encrypted.",
  "req.step3_title": "Upload your documents",
  "req.step3_subtitle": "Drag or pick the files. We accept PDF and JPG up to 10 MB.",
  "req.step4_title": "Let's review",
  "req.step4_subtitle": "Check that everything is right before sending.",
  "req.doc_cedula": "Government ID",
  "req.doc_cedula_hint": "Front and back scanned or a clear photo.",
  "req.doc_rut": "RUT (tax registry)",
  "req.doc_rut_hint": "Issued within the last 30 days.",
  "req.doc_camara": "Chamber of Commerce certificate",
  "req.doc_camara_hint": "Issued within the last 30 days. Legal entities only.",
  "req.field_name": "Full name",
  "name.first": "First given name",
  "name.second": "Second given name",
  "name.first_surname": "First surname",
  "name.second_surname": "Second surname",
  "name.dian_hint": "Name on file at DIAN:",
  "name.company": "Company name",
  "req.field_doc_type": "Document type",
  "req.field_doc_number": "Document number",
  "req.field_email": "Email",
  "req.field_phone": "Phone",
  "req.field_city": "City",
  "req.field_department": "Department",
  "req.select_department": "Select a department",
  "req.select_city": "Select a city",
  "req.select_city_first": "Choose a department first",
  "req.field_address": "Address",
  "req.field_validity": "Certificate validity",
  "req.validity_1": "1 year",
  "req.validity_2": "2 years",
  "req.validity_3": "3 years",
  "req.validity_m3": "3 months",
  "req.validity_m6": "6 months",
  "req.validity_single_option": "The available validity for this request is {label}.",
  "req.price_from": "From {price}",
  "req.submit": "Submit request",
  "req.success_title": "All set! We got your request",
  "req.success_body": "We'll email {email} in less than 24 hours with next steps.",
  "req.success_ref": "Reference",
  "req.success_go_dashboard": "Go to home",

  "docs.title": "My documents",
  "docs.subtitle": "Store your documents to reuse them in future requests.",
  "docs.upload": "Upload document",
  "docs.drop_title": "Drag your file here",
  "docs.drop_subtitle": "or click to browse your device",
  "docs.drop_formats": "PDF, JPG or PNG · up to 10 MB",
  "docs.empty_title": "No documents yet",
  "docs.empty_body": "Upload documents you use often and they'll be ready for your next request.",
  "docs.type_cedula": "ID",
  "docs.type_rut": "RUT",
  "docs.type_camara_comercio": "Chamber of Commerce",
  "docs.type_poder": "Power of attorney",
  "docs.type_otro": "Other",
  "docs.uploaded_on": "Uploaded",
  "docs.size": "Size",

  "profile.title": "My profile",
  "profile.subtitle": "Your personal and contact info.",
  "profile.personal": "Personal",
  "profile.contact": "Contact",
  "profile.notifications": "Notifications",
  "profile.language": "Language",
  "profile.danger": "Danger zone",
  "profile.delete": "Delete account",
  "profile.notif_email": "Email me about my certificates' status",
  "profile.notif_expiry": "Remind me 30 days before expiry",
  "profile.notif_marketing": "News and tips from PahCertificar",

  "help.title": "Help",
  "help.subtitle": "Quick answers and ways to reach us.",
  "help.search_placeholder": "Search a question…",
  "help.contact_title": "Prefer to talk to someone?",
  "help.contact_body": "Our team replies in less than a business day.",
  "help.contact_email": "Send email",
  "help.contact_whatsapp": "Open WhatsApp",

  "chat.need_help": "Need help?",
  "chat.hint": "Ask us anything",

  "auth.secure_signin": "Secure sign-in",
  "auth.login_title": "Welcome to your certificate portal",
  "auth.login_subtitle":
    "Sign in with your WhatsApp number. No passwords — we send a 6-digit code via WhatsApp and you're in.",
  "auth.signin_cta": "Continue with WhatsApp",
  "auth.feature_whatsapp": "We send a 6-digit code to your WhatsApp",
  "auth.feature_no_password": "No passwords — your phone is your identity",
  "auth.legal_prefix": "By continuing you accept the",
  "auth.legal_privacy": "privacy policy",
  "auth.legal_and": "and the",
  "auth.legal_terms": "terms",
  "auth.callback_working_title": "Verifying your session",
  "auth.callback_working_body":
    "We're confirming your code and getting you into the portal. Just a few seconds.",
  "auth.callback_error_title": "We couldn't sign you in",
  "auth.callback_error_body":
    "The code expired or the link is no longer valid. Try signing in again and we'll send a new one.",
  "auth.phone_label": "WhatsApp number",
  "auth.role_admin": "Admin",
  "auth.role_user": "Customer",

  "onb.step_doc": "Your document",
  "onb.step_code": "Email code",
  "onb.secure_step": "Secure step · 1 of 2",
  "onb.doc_title": "Let's verify your identity",
  "onb.doc_subtitle":
    "We need your document type and number to confirm who you are and pull the email registered with DIAN.",
  "onb.phone_verified": "Your WhatsApp is verified",
  "onb.doc_type": "Document type",
  "onb.doc_number": "Document number",
  "onb.doc_helper":
    "We look you up in DIAN. Nothing is saved until you enter the code that arrives in your email.",
  "onb.continue": "Look up and send code",
  "onb.privacy_note":
    "By continuing you authorize us to look up your name and email at DIAN to verify your identity.",
  "onb.email_sent": "We sent a code to your email",
  "onb.email_sent_chip": "Email sent · 6 digits",
  "onb.email_resent": "We resent the code",
  "onb.greeting": "Hi, {name} 👋",
  "onb.code_subtitle": "We sent a 6-digit code to",
  "onb.code_label": "Code from your email",
  "onb.verify": "Verify and continue",
  "onb.resend": "Resend code",
  "onb.change_doc": "Wrong document?",
  "onb.welcome": "All set! Welcome",
  "onb.unlocking": "Loading your portal…",
  "onb.err_doc_required": "Enter your document number.",
  "onb.err_not_found":
    "We couldn't find this document at DIAN. Check the type and number, or contact us.",
  "onb.err_code_format": "The code must be 6 digits.",
  "onb.err_unknown": "Something went wrong. Try again.",

  "req.price_title": "Certificate cost",
  "req.price_subtitle": "One-time payment, VAT included. Invoice e-mailed to you.",
  "req.price_includes_dian": "E-invoicing request flow",
  "req.price_includes_issuer": "An accredited digital certification entity evaluates and, if approved, issues",
  "req.price_includes_support": "Human WhatsApp support",
  "req.approval_conditional": "Payment starts the review but does not guarantee approval, issuance, or a fixed timeline. The certification entity may request more information or reject the application under its policies.",
  "req.price_secure_checkout": "Secure checkout via Nequi",
  "req.total": "Total",
  "req.pay_and_submit": "Pay and submit",
  "pay.checking_title": "Confirming your payment",
  "pay.checking_body": "We're checking with Nequi. Just a few seconds.",
  "pay.success_title": "Payment received!",
  "pay.success_body": "Your request is in review. We'll WhatsApp you when there is an update.",
  "pay.go_home": "Go home",
  "pay.cancelled_title": "Payment cancelled",
  "pay.cancelled_body": "No worries, you weren't charged. You can try again whenever you're ready.",
  "pay.failed_title": "Couldn't confirm your payment",
  "pay.failed_body": "The provider reported an error or the link expired. Please retry the request.",
  "pay.taking_too_long": "Taking longer than usual. If you already paid, we'll WhatsApp you as soon as we confirm.",
  "pay.retry": "Try again",
  "pay.push_title": "Check your Nequi 📱",
  "pay.push_body":
    "We pay only with Nequi. We sent a notification to your app — you have 3 minutes to approve it.",
  "pay.push_step1": "Open the Nequi app on this phone",
  "pay.push_step2": "Tap the PAH VENTURE SAS payment request",
  "pay.push_step3": "Confirm {amount} with your Nequi PIN",
  "pay.push_step3_generic": "Confirm the payment with your Nequi PIN",
  "pay.push_listening": "Waiting for your approval…",

  "nequi.dialog_title": "Confirm your Nequi",
  "nequi.dialog_subtitle":
    "We pay only with Nequi. We'll push a {amount} request to your Nequi app so you can approve it from your phone.",
  "nequi.phone_label": "Phone with Nequi",
  "nequi.phone_helper":
    "If your Nequi is on a different phone, type that number here. You aren't charged until you approve in the Nequi app.",
  "nequi.confirm": "Send request to my Nequi",
  "nequi.dialog_disclaimer":
    "Secure payment. Final approval happens inside your Nequi app.",
  "nequi.err_not_found":
    "This phone doesn't have a Nequi account. Double-check the number or try a different one.",
};

export default en;
